import React from 'react'
import { WrappedFieldProps } from 'redux-form'
import { IColorInputProps } from './index'

type C = React.ComponentType<IColorInputProps>

function withRedux(Component: C) {
  return function({
                    input,
                    meta,
                    ...rest
                  }: WrappedFieldProps & IColorInputProps) {
    return (
      <Component
        name={input.name}
        value={input.value}
        onChange={input.onChange}
        errorMsg={meta.touched && meta.error}
        warningMsg={meta.touched && meta.warning}
        {...rest}
      />
    )
  }
}

export default withRedux
